import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-30 md:opacity-100">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20flowing%20film%20strips%20and%20warm%20golden%20light%20rays%20streaming%20through%20a%20dark%20theater%20space%20artistic%20motion%20blur%20rich%20amber%20and%20deep%20crimson%20tones%20dreamy%20atmosphere%20no%20text%20no%20people&width=900&height=800&seq=hero-main-visual&orientation=portrait"
          alt="91在线视频主视觉"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/90 to-transparent md:via-background-50/70 md:to-transparent"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
            <div className="w-full">
              <span className="inline-block px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-5 whitespace-nowrap">
                {heroData.tag}
              </span>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight mb-4">
                91在线视频
                <br />
                <span className="text-primary-500">海量免费影视 · 高清流畅观影</span>
              </h1>

              <p className="text-lg text-primary-600 font-medium mb-6 font-heading">
                {heroData.slogan}
              </p>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl">
                {heroData.description}
              </p>

              <div className="flex flex-wrap items-center gap-6 mb-8">
                {heroData.stats.map((stat, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <span className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                      {stat.value}
                    </span>
                    <span className="text-xs md:text-sm text-foreground-500">{stat.label}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href={heroData.primaryCta.href}
                  onClick={(e) => handleClick(e, heroData.primaryCta.href)}
                  className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  {heroData.primaryCta.label}
                </a>
                <a
                  href={heroData.secondaryCta.href}
                  onClick={(e) => handleClick(e, heroData.secondaryCta.href)}
                  className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-foreground-200 text-foreground-700 font-medium rounded-full hover:border-primary-300 hover:text-primary-500 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
                >
                  {heroData.secondaryCta.label}
                </a>
              </div>
            </div>

            <div className="hidden md:block relative">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20home%20theater%20with%20large%20screen%20displaying%20cinematic%20content%20warm%20ambient%20lighting%20cozy%20atmosphere%20orange%20and%20amber%20tones%20comfortable%20seating%20high%20quality%20interior%20design&width=700&height=500&seq=hero-feature&orientation=landscape"
                  alt="91在线视频观影体验"
                  className="w-full rounded-2xl"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-background-50 rounded-xl px-5 py-3 border border-background-200/70">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                  <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">每日更新中</span>
                </div>
              </div>
              <div className="absolute -top-3 -right-3 bg-accent-500 text-background-50 rounded-full w-12 h-12 flex items-center justify-center">
                <i className="ri-fire-line text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}